import { useState } from '@wordpress/element';
// import './Card.css';
import styles from "./Card.module.css";
const Card = ({ title, icon, children, collapsible = false, defaultCollapsed = false }) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  
  const toggleCollapse = () => {
    if (collapsible) {
      setIsCollapsed(!isCollapsed);
    }
  };
  
  return (
    
       <div className={styles["hvnly-settings-api__card"]}>
      <div 
        className={styles["hvnly-settings-api__card-header"]}
        onClick={toggleCollapse}
        style={{ cursor: collapsible ? 'pointer' : 'default' }}
      >
        {icon && <i className={icon}></i>}
        {title}
        {collapsible && (
          <i 
            className={`fas fa-chevron-${isCollapsed ? 'down' : 'up'}`} 
            style={{ marginLeft: 'auto' }}
          ></i>
        )}
      </div>
      
      {!isCollapsed && (
        <div className={styles["hvnly-settings-api__card-body"]}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Card;